import { Component, Input, OnChanges } from '@angular/core';
import { TransformedRecipientReportData } from '../../../pages/organization/campaigns/types/campaignDetails';
import { EmptyStateComponent } from '../../ui/empty-state/empty-state.component';
import { DataTableComponent } from '../../ui/data-table/data-table.component';
import { formatCount } from '../../../../utils/sms';

interface GroupRow {
  key: string;
  type: string;
  name: string;
  recipients: string;
  male: string;
  female: string;
  other: string;
  young: string;
  middle: string;
  older: string;
}

const TYPE_LABEL: Record<string, string> = {
  organization: 'Organization',
  tags: 'Tag',
  segments: 'Segment',
};

/** Each recipient group with its audience by gender and age. */
@Component({
  selector: 'app-campaign-recipients-report-table',
  standalone: true,
  imports: [EmptyStateComponent, DataTableComponent],
  templateUrl: './campaign-recipients-report-table.component.html',
  styleUrl: './campaign-recipients-report-table.component.css',
})
export class CampaignRecipientsReportTableComponent implements OnChanges {
  @Input({ required: true }) recipientData: TransformedRecipientReportData[] = [];
  @Input() loading = false;

  rows: GroupRow[] = [];

  ngOnChanges() {
    const groups = Array.isArray(this.recipientData) ? this.recipientData : [];
    const count = (value: unknown) => formatCount(Number(value) || 0);
    this.rows = groups
      .filter((group) => !!group)
      .flatMap((group) =>
        (Array.isArray(group.groupList) ? group.groupList : [])
          .filter((item) => !!item)
          .map((item, i): GroupRow => ({
            key: `${group.groupName}-${item.groupUuid ?? i}`,
            type: TYPE_LABEL[group.groupName] ?? group.groupName,
            name: String(item.groupName ?? '').trim() || 'Unnamed group',
            recipients: count(item.totalRecipient),
            male: count(item.totalMale),
            female: count(item.totalFemale),
            other: count(item.other),
            young: count(item.ageSixteenThirtyFive),
            middle: count(item.ageThirtySixSixtyFive),
            older: count(item.ageSixtySixOneTwenty),
          }))
      );
  }
}
